export const MODAL_NAMES = {
  ABOUT_BATTERY: 'about_battery',
  PAYPAY: 'paypay',
  VERIFIED_REFURBISHED_JPP: 'VERIFIED_REFURBISHED_JPP',
  SELLER_INFO: 'SELLER_INFO',
  SIM_UNLOCKED: 'SIM_UNLOCKED',
  BACK_UP: 'BACK_UP',
  CONDITION: 'CONDITION',
  ADD_TO_CART: 'ADD_TO_CART',
}
